import React from 'react';
import { Loader2 } from 'lucide-react';

export default function LoadingOverlay({ label = 'Loading…' }) {
  return (
    <div className="flex flex-col items-center justify-center py-10 text-[#4A5A50] gap-2" data-testid="loading-overlay">
      <Loader2 className="w-6 h-6 animate-spin" />
      <span className="text-sm">{label}</span>
    </div>
  );
}
